(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-custom"]) return;
  try {
    
  class HeaderNavCustom extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.header-custom__nav-item.has-dropdown'));
      this.overlay = this.querySelector('.header-custom__overlay');

      this.items.forEach(item => {
        const btn = item.querySelector('.header-custom__nav-btn');
        const mega = item.querySelector('.header-custom__mega');
        if (!btn || !mega) return;

        btn.addEventListener('click', () => {
          if (item.classList.contains('is-open')) {
            this._closeAll();
          } else {
            this._open(item, btn, mega);
          }
        });

        btn.addEventListener('keydown', e => {
          if (e.key === 'Escape') { this._closeAll(); btn.focus(); }
          if (e.key === 'ArrowDown') { e.preventDefault(); mega.querySelector('a')?.focus(); }
        });

        mega.addEventListener('keydown', e => {
          if (e.key === 'Escape') { this._closeAll(); btn.focus(); }
        });
      });

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this._closeAll());
      }

      document.addEventListener('click', e => {
        if (!this.contains(e.target)) this._closeAll();
      });
    }

    _open(item, btn, mega) {
      this._closeAll();
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      mega.removeAttribute('hidden');
      if (this.overlay) this.overlay.classList.add('is-visible');
    }

    _closeAll() {
      clearTimeout(this._closeTimer);
      this.items.forEach(item => {
        const btn = item.querySelector('.header-custom__nav-btn');
        const mega = item.querySelector('.header-custom__mega');
        if (btn && mega) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          mega.setAttribute('hidden', '');
        }
      });
      if (this.overlay) this.overlay.classList.remove('is-visible');
    }
  }

  if (!customElements.get('header-nav-custom')) {
    customElements.define('header-nav-custom', HeaderNavCustom);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class HeaderSearchCustom extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.header-custom__search-input');
      this.panel = this.querySelector('.header-custom__search-results');
      this.list = this.querySelector('.header-custom__search-results-list');
      this.loader = this.querySelector('.header-custom__search-loading');
      this._timer = null;
      this._currency = '{{ cart.currency.iso_code }}';

      this.input.addEventListener('input', () => this._onInput());
      this.input.addEventListener('focus', () => { if (this.list.children.length) this._show(); });
      document.addEventListener('click', e => { if (!this.contains(e.target)) this._hide(); });
    }

    _onInput() {
      clearTimeout(this._timer);
      const q = this.input.value.trim();
      if (q.length < 2) { this._hide(); return; }
      this._timer = setTimeout(() => this._search(q), 300);
    }

    async _search(q) {
      this.loader.style.display = 'block';
      this.list.innerHTML = '';
      this._show();
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const { resources } = await res.json();
        this._render(resources.results.products || []);
      } catch {
        this.list.innerHTML = '<div class="header-custom__search-no-results">Något gick fel</div>';
      } finally {
        this.loader.style.display = 'none';
      }
    }

    _render(products) {
      if (!products.length) {
        this.list.innerHTML = '<div class="header-custom__search-no-results">Inga produkter hittades</div>';
        return;
      }
      this.list.innerHTML = products.map(p => {
        const img = p.featured_image
          ? `<img src="${p.featured_image}" alt="${p.title}" class="header-custom__search-result-image" loading="lazy">`
          : '';
        const price = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: this._currency }).format(p.price / 100);
        const vendor = p.vendor ? `<p class="header-custom__search-result-vendor">${p.vendor}</p>` : '';
        return `<a href="${p.url}" class="header-custom__search-result">${img}<div class="header-custom__search-result-info"><p class="header-custom__search-result-title">${p.title}</p>${vendor}<p class="header-custom__search-result-price">${price}</p></div></a>`;
      }).join('');
    }

    _show() { this.panel.classList.add('is-open'); }
    _hide() { this.panel.classList.remove('is-open'); }
  }

  if (!customElements.get('header-search-custom')) {
    customElements.define('header-search-custom', HeaderSearchCustom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
